// extracted by mini-css-extract-plugin
module.exports = {"BaseLayout":"BaseLayout_BaseLayout__2_snz","withHeader":"BaseLayout_withHeader__3sCR0"};